export default "__VITE_ASSET__u5aeRNMz__"